import { AxiosInstance } from 'axios'
import { axiosProxy } from '@/plugins/axios'
import { ErrorHandler } from '@/utils/ErrorHandler'
import { STORE_LANG } from '@/AppKeys'
import theLocaleStorage from './LocalStorage'

export class LocaleUtils {
  private api: AxiosInstance = axiosProxy

  private locale = 'en'
  private handler = new ErrorHandler()

  async getUserLocale(): Promise<string> {

    await this.handler.handle(async () => {

      const url = 'https://geolocation-250000770061.europe-west1.run.app'
      const res = await this.api.get(url)

      if (res.data && res.data.country) {
        this.locale = res.data.country.toLowerCase()
      }
    })

    return this.locale
  }

  static getLocaleFromSubDomain(): 'en' | 'fi' | 'se' {
    if (window.location.hostname === 'localhost') {
      return 'en'
    }

    if (LocaleUtils.isDefaultDomain()) { // For taiko.art we want locale be fi as default
      return 'fi'
    }
    const host = window.location.host
    const parts = host.split('.')
    const lang = parts[0]
    if (lang === 'en' || lang === 'fi' || lang === 'se') {
      return lang
    }
    return 'fi'
  }

  static isDefaultDomain(): boolean {
    const host = window.location.host
    const parts = host.split('.')
    return parts.length < 3 || parts[0] === 'www'
  }

  static saveLocale(lang: 'en' | 'fi' | 'es') {
    theLocaleStorage.set(STORE_LANG, lang)
  }
}
